export const scrollToHash = (hash) => {
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (hash) {
    const el = document.getElementById(hash);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.15 });
    else el.scrollIntoView({ behavior: "smooth", block: "start" });
  } else if (lenis) {
    lenis.scrollTo(0, { immediate: true });
  } else {
    window.scrollTo(0, 0);
  }
};

export const useSectionNav = (navigate, location) => (hash) => (event) => {
  if (event) event.preventDefault();
  if (location.pathname !== "/") {
    navigate(hash ? `/#${hash}` : "/", { state: hash ? { scroll: hash } : undefined });
  } else {
    scrollToHash(hash);
  }
};